import React, { useState, useEffect } from 'react';
import { HashRouter, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AuthModal from './components/AuthModal';
import WhatsAppButton from './components/WhatsAppButton';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import IndividualTaxFiling from './pages/IndividualTaxFiling';
import BusinessTaxFiling from './pages/BusinessTaxFiling';
import GlobalIncomeReporting from './pages/GlobalIncomeReporting';
import ITINApplication from './pages/ITINApplication';
import TaxPlanning from './pages/TaxPlanning';
import BusinessFormation from './pages/BusinessFormation';
import PayrollProcessing from './pages/PayrollProcessing';
import Bookkeeping from './pages/Bookkeeping';
import FormsLinks from './pages/FormsLinks';
import FAQs from './pages/FAQs';
import Blogs from './pages/Blogs';
import Contact from './pages/Contact';
import VerifyEmail from './pages/VerifyEmail';
import ResetPassword from './pages/ResetPassword';
import ClientDashboard from './pages/ClientDashboard';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import { authApi } from './services/authService';
import './App.css';

const ProtectedRoute = ({ children }) => {
  if (!authApi.isLoggedIn()) return <Navigate to="/" replace />;
  return children;
};

const AdminRoute = ({ children }) => {
  if (!localStorage.getItem('preciseo_admin_token')) return <Navigate to="/admin/login" replace />;
  return children;
};

const AppContent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [authModal, setAuthModal] = useState({ isOpen: false, mode: 'login', message: '' });
  const [isLoggedIn, setIsLoggedIn] = useState(authApi.isLoggedIn());
  const [currentUser, setCurrentUser] = useState(authApi.getStoredUser());

  useEffect(() => {
    const checkAuth = async () => {
      if (authApi.isLoggedIn()) {
        const user = await authApi.getCurrentUser();
        if (user) { setCurrentUser(user); setIsLoggedIn(true); }
        else { setIsLoggedIn(false); setCurrentUser(null); }
      }
    };
    checkAuth();
  }, []);

  const openAuth = (mode = 'login', message = '') => setAuthModal({ isOpen: true, mode, message });
  const closeAuth = () => setAuthModal(prev => ({ ...prev, isOpen: false, message: '' }));
  const handleLoginSuccess = (user) => { setIsLoggedIn(true); setCurrentUser(user); };
  const handleLogout = () => { authApi.logout(); setIsLoggedIn(false); setCurrentUser(null); navigate('/'); };
  const handleEmailVerified = () => openAuth('login', 'Email verified! Please login.');
  const handleResetSuccess = () => openAuth('login', 'Password reset! Please login.');
  const handleNavbarAuthClick = () => isLoggedIn ? navigate('/dashboard') : openAuth('login');

  const isAdminPage = location.pathname.startsWith('/admin');
  const isDashboardPage = location.pathname === '/dashboard';
  const hideNavFooter = isAdminPage || isDashboardPage;

  return (
    <div className="flex flex-col min-h-screen">
      <ScrollToTop />
      {!hideNavFooter && <Navbar onOpenAuth={handleNavbarAuthClick} isLoggedIn={isLoggedIn} user={currentUser} />}
      <main className={`flex-grow ${!hideNavFooter ? 'pt-16' : ''}`}>
        <Routes>
          <Route path="/" element={<Home onOpenAuth={() => openAuth('signup')} />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/individual-tax-filing" element={<IndividualTaxFiling />} />
          <Route path="/services/business-tax-filing" element={<BusinessTaxFiling />} />
          <Route path="/services/fbar-fatca" element={<GlobalIncomeReporting />} />
          <Route path="/services/itin-application" element={<ITINApplication />} />
          <Route path="/services/tax-planning" element={<TaxPlanning />} />
          <Route path="/services/business-formation" element={<BusinessFormation />} />
          <Route path="/services/payroll-processing" element={<PayrollProcessing />} />
          <Route path="/services/bookkeeping" element={<Bookkeeping />} />
          <Route path="/forms-links" element={<FormsLinks />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/verify/:token" element={<VerifyEmail onVerified={handleEmailVerified} />} />
          <Route path="/reset-password/:token" element={<ResetPassword onResetSuccess={handleResetSuccess} />} />
          <Route path="/dashboard" element={<ProtectedRoute><ClientDashboard onLogout={handleLogout} /></ProtectedRoute>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
        </Routes>
      </main>
      {!hideNavFooter && <Footer />}
      <WhatsAppButton />
      {authModal.isOpen && <AuthModal initialMode={authModal.mode} initialMessage={authModal.message} onClose={closeAuth} onLoginSuccess={handleLoginSuccess} />}
    </div>
  );
};

function App() {
  return <HashRouter><AppContent /></HashRouter>;
}

export default App;